import { render, staticRenderFns } from "./surplusSheet.vue?vue&type=template&id=2f172ade"
import script from "./surplusSheet.vue?vue&type=script&lang=js"
export * from "./surplusSheet.vue?vue&type=script&lang=js"
import style0 from "./surplusSheet.vue?vue&type=style&index=0&id=2f172ade&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f172ade')) {
      api.createRecord('2f172ade', component.options)
    } else {
      api.reload('2f172ade', component.options)
    }
    module.hot.accept("./surplusSheet.vue?vue&type=template&id=2f172ade", function () {
      api.rerender('2f172ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/surplusSheet.vue"
export default component.exports